import { useBaseApi } from './use-base-api'

/**
 * 商品相关的API调用
 */
export function useProductApi() {
  const { request } = useBaseApi()

  // 获取商品列表
  const getProducts = async (params?: Record<string, any>) => {
    return request<{ data: any[]; total: number }>('/admin-products', {
      params,
    })
  }

  // 获取单个商品
  const getProduct = async (id: string) => {
    return request(`/admin-products/${id}`)
  }

  // 创建商品
  const createProduct = async (data: any) => {
    return request<any>('/admin-products', {
      method: 'POST',
      data,
    })
  }

  const uploadFile = async (formData: FormData) => {
    return request<any>('/admin-products/upload-file', {
      method: 'POST',
      data: formData,
    })
  }
  // 更新商品
  const updateProduct = async (id: string, data: any) => {
    return request<any>(`/admin-products/${id}`, {
      method: 'PUT',
      data,
    })
  }

  // 删除商品
  const deleteProduct = async (id: string) => {
    return request<void>(`/admin-products/${id}`, {
      method: 'DELETE',
    })
  }

  return {
    getProducts,
    getProduct,
    createProduct,
    updateProduct,
    deleteProduct,
    uploadFile,
  }
}
